module.exports = require("@wildboar/x500/src/lib/matching/substring/caseIgnoreIA5SubstringsMatch");